import { APP_CONNECT_SUCCESS, LOAD_COUNTRY_LIST_SUCCESS } from '../actions/appActions';

const initialState = {
  connected: false,
  tenant: {
    id: null,
    name: null,
    default_language: null
  },
  countryList: []
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case APP_CONNECT_SUCCESS:
      return {
        ...state,
        connected: true,
        tenant: {
          id: action.payload.id,
          name: action.payload.name,
          default_language: action.payload.default_language
        }
      };
    
    case LOAD_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        countryList: action.payload
      };

    default:
      return state;
  }
}
